import { BaseCSSProperties } from '@material-ui/core/styles/withStyles';
import AeonikLightWoff2 from '../../assets/fonts/aeonik-essentials/Aeonik-Light.woff2';
import AeonikLightWoff from '../../assets/fonts/aeonik-essentials/Aeonik-Light.woff';
import AeonikRegularWoff2 from '../../assets/fonts/aeonik-essentials/Aeonik-Regular.woff2';
import AeonikRegularWoff from '../../assets/fonts/aeonik-essentials/Aeonik-Regular.woff';
import AeonikMediumWoff2 from '../../assets/fonts/aeonik-essentials/Aeonik-Medium.woff2';
import AeonikMediumWoff from '../../assets/fonts/aeonik-essentials/Aeonik-Medium.woff';
import AeonikMediumItalicWoff2 from '../../assets/fonts/aeonik-essentials/Aeonik-MediumItalic.woff2';
import AeonikMediumItalicWoff from '../../assets/fonts/aeonik-essentials/Aeonik-MediumItalic.woff';
import AeonikSemiBoldWoff2 from '../../assets/fonts/aeonik-essentials/Aeonik-SemiBold.woff2';
import AeonikSemiBoldWoff from '../../assets/fonts/aeonik-essentials/Aeonik-SemiBold.woff';
import AeonikSemiBoldItalicWoff2 from '../../assets/fonts/aeonik-essentials/Aeonik-SemiBoldItalic.woff2';
import AeonikSemiBoldItalicWoff from '../../assets/fonts/aeonik-essentials/Aeonik-SemiBoldItalic.woff';
import AeonikBoldWoff2 from '../../assets/fonts/aeonik-essentials/Aeonik-Bold.woff2';
import AeonikBoldWoff from '../../assets/fonts/aeonik-essentials/Aeonik-Bold.woff';
import AeonikBoldItalicWoff2 from '../../assets/fonts/aeonik-essentials/Aeonik-BoldItalic.woff2';
import AeonikBoldItalicWoff from '../../assets/fonts/aeonik-essentials/Aeonik-BoldItalic.woff';

const AeonikLight: BaseCSSProperties['@font-face'] = {
  fontFamily: 'Aeonik',
  fontStyle: 'normal',
  fontWeight: 300,
  fontDisplay: 'swap',
  src: `
  url(${AeonikLightWoff2}) format('woff2'),
  url(${AeonikLightWoff}) format('woff')
  `
};

const AeonikRegular: BaseCSSProperties['@font-face'] = {
  fontFamily: 'Aeonik',
  fontStyle: 'normal',
  fontWeight: 400,
  fontDisplay: 'swap',
  src: `
  url(${AeonikRegularWoff2}) format('woff2'),
  url(${AeonikRegularWoff}) format('woff')
  `
};

const AeonikMedium: BaseCSSProperties['@font-face'] = {
  fontFamily: 'Aeonik',
  fontStyle: 'normal',
  fontWeight: 500,
  fontDisplay: 'swap',
  src: `
  url(${AeonikMediumWoff2}) format('woff2'),
  url(${AeonikMediumWoff}) format('woff')
  `
};

const AeonikMediumItalic: BaseCSSProperties['@font-face'] = {
  fontFamily: 'Aeonik',
  fontStyle: 'italic',
  fontWeight: 500,
  fontDisplay: 'swap',
  src: `
  url(${AeonikMediumItalicWoff2}) format('woff2'),
  url(${AeonikMediumItalicWoff}) format('woff')
  `
};

const AeonikSemiBold: BaseCSSProperties['@font-face'] = {
  fontFamily: 'Aeonik',
  fontStyle: 'normal',
  fontWeight: 600,
  fontDisplay: 'swap',
  src: `
  url(${AeonikSemiBoldWoff2}) format('woff2'),
  url(${AeonikSemiBoldWoff}) format('woff')
  `
};

const AeonikSemiBoldItalic: BaseCSSProperties['@font-face'] = {
  fontFamily: 'Aeonik',
  fontStyle: 'italic',
  fontWeight: 600,
  fontDisplay: 'swap',
  src: `
  url(${AeonikSemiBoldItalicWoff2}) format('woff2'),
  url(${AeonikSemiBoldItalicWoff}) format('woff')
  `
};

const AeonikBold: BaseCSSProperties['@font-face'] = {
  fontFamily: 'Aeonik',
  fontStyle: 'normal',
  fontWeight: 700,
  fontDisplay: 'swap',
  src: `
  url(${AeonikBoldWoff2}) format('woff2'),
  url(${AeonikBoldWoff}) format('woff')
  `
};

const AeonikBoldItalic: BaseCSSProperties['@font-face'] = {
  fontFamily: 'Aeonik',
  fontStyle: 'italic',
  fontWeight: 700,
  fontDisplay: 'swap',
  src: `
  url(${AeonikBoldItalicWoff2}) format('woff2'),
  url(${AeonikBoldItalicWoff}) format('woff')
  `
};

export const AeonikFont = [
  AeonikLight,
  AeonikRegular,
  AeonikMedium,
  AeonikMediumItalic,
  AeonikSemiBold,
  AeonikSemiBoldItalic,
  AeonikBold,
  AeonikBoldItalic,
]
